// Load the preference widgets
document.addEventListener("DOMContentLoaded", function (event) {

	GetWidget("2", "D0A47C10-5DA3-412D-9232-B6073B69BD3D", "D0A47C10-5DA3-412D-9232-B6073B69BD3D", "PrefWidget", "00" ,getLang());
	var CookieConsentID = checkCookie("CookieConsentID")
  
  function getRootDomain(url) {
    try {
      const domain = new URL(url).hostname;
      const elems = domain.split(".");
      const iMax = elems.length - 1;
      const isSecondLevel =
        elems.length >= 3 && (elems[iMax] + elems[iMax - 1]).length <= 5;
      return elems.splice(isSecondLevel ? -3 : -2).join(".");
    } catch (error) {
      return null;
    }
  }

  function loadScript(src, onSuccess, onError) {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      if (onSuccess) onSuccess();
    };
    script.onerror = () => {
      if (onError) onError();
    };
    document.head.appendChild(script);
  }

  function initCassieWidget() {
    window.onload = function () {
      GetWidget(
        "2",
        "D0A47C10-5DA3-412D-9232-B6073B69BD3D",
        "D0A47C10-5DA3-412D-9232-B6073B69BD3D",
        "PrefWidget",
        "10",
        getLang()
      );
      var CookieConsentID = checkCookie("CookieConsentID");
    };
  }

  function loadScriptWithFallback() {
    const rootDomain = getRootDomain(window.location.href);
    let scriptUrl = rootDomain
      ? `https://wscript-cdn-use.${rootDomain}/widget.js`
      : "https://wscript-cdn-use.cassiecloud.com/widget.js";
    window.cassieResourceRootDomain = rootDomain;

    loadScript(
      scriptUrl,
      () => {
        initCassieWidget();
      },
      () => {
        window.cassieResourceRootDomain = null;
        loadScript(
          "https://wscript-cdn-use.cassiecloud.com/widget.js",
          () => {
            initCassieWidget();
          }
        );
      }
    );
  }

  loadScriptWithFallback();
});

// Save the preference widget contents to Cassie after Shopify has validated the form on server side
function SubmitWidget(intID) {
  var WidgetId = intID;
  console.log("Starting save");
  SaveWidget(WidgetId, "D0A47C10-5DA3-412D-9232-B6073B69BD3D", "PrefWidget");
}

function SaveWidget(FormID, LicenseID, DivID) {
  var PostURL = "https://wscript-use.niuriss.com/widgetsapi/submit";
/*
  if (window.cassieResourceRootDomain != null) {
    PostURL = PostURL.replace(
      "cassiecloud.com",
      window.cassieResourceRootDomain
    );
  }
*/  
  var ObjectArray = []; // Define an empty Object Array
  var RecordObject = {}; // Define an empty Record Object for holding data
  /*
   * Forename, Surname and Email1 are required fields within the RecordObject,
   * the remaining fields are optional and need not be defined at all unless
   * you plan to use them.
   */
  //*** Scrape form fields for matching ***//
  RecordObject.DivID = DivID; // This is the name of the container that holds the Cassie widget.
  let NoCassiesubmit = 0;
  RecordObject.LanguageCode = cassieWidgetLanguageCode;
  if (
    document.getElementsByName("contact[first-name]")[0] != undefined &&
    document.getElementsByName("contact[first-name]")[0].length != 0
  ) {
    RecordObject.Forename = document.getElementsByName(
      "contact[first-name]"
    )[0].value;
    NoCassiesubmit++;
  } else {
    RecordObject.Forename = "";
  }
  if (
    document.getElementsByName("contact[last-name]")[0] != undefined &&
    document.getElementsByName("contact[last-name]")[0].length != 0
  ) {
    RecordObject.Surname =
      document.getElementsByName("contact[last-name]")[0].value;
    NoCassiesubmit++;
  } else {
    RecordObject.Surname = "";
  }
  if (
    document.getElementsByName("contact[email]")[0] != undefined &&
    document.getElementsByName("contact[email]")[0].length != 0
  ) {
    RecordObject.Email1 = document.getElementsByName("contact[email]")[0].value;
    RecordObject.Email1 = encodeURIComponent(RecordObject.Email1);
    NoCassiesubmit++;
  } else {
    RecordObject.Email1 = "";
  }
  if (document.getElementsByName("contactid")[0] != undefined) {
    if (document.getElementsByName("contactid")[0].value !== "") {
      RecordObject.URN2 = document.getElementsByName("contactid")[0].value;
    } else {
      RecordObject.URN2 = ""
    }
  }  
  //If we have a cookie preference already saved for this record, then add it to the record object for processing
  if ((NoCassiesubmit = 3)) {
    var deviceGUID = document.cookie.replace(
      /(?:(?:^|.*;\s*)SyrenisGuid_.+?\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );
    if (deviceGUID != "") {
      RecordObject.DeviceGUID = deviceGUID;
    }
    //*** Process preferences ***//
    // Add preferences to RecordObject, and RecordObject to ObjectArray
    RecordObject.Preferences = GetPreferencesArray();
    ObjectArray.push(RecordObject);
    RecordObject.FormID = FormID;
    RecordObject.LicenseID = LicenseID;
    //Log values
    //console.log("PostURL=" + PostURL);
    //console.log("RecordObject = " + JSON.stringify(RecordObject));
    // Post the data to the Cassie web service
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open("POST", PostURL, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status === 200) {
          //Submit form as usual
          window.Shopify.recaptchaV3.addToken(this, "contact");
          form.submit();
        }
      }
    };
    var JSONRecordObject = JSON.stringify(RecordObject);
    xmlhttp.send(JSONRecordObject);
  }
}




